.containerError {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}

.errorPdf {
  background-color: #f36565;
  border-radius: 0.25rem;
  color: #fff;
  padding: 0.5rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 4px;
}

.pageNavigation {
  display: flex;
  gap: 8px;
  align-items: center;
}

.pageInput {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

.pageInput:focus {
  outline: none;
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.contentWrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
}

.thumbnailsSidebar {
  width: 150px;
  min-width: 150px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  flex-shrink: 0;
}

.thumbnailItem {
  margin-bottom: 15px;
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
}

.thumbnailItem:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-color: var(--bs-primary);
}

.thumbnailLabel {
  text-align: center;
  font-size: 12px;
  padding: 5px;
  background-color: white;
  font-weight: 500;
}

.scrollContainer {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

.page {
  margin-bottom: 20px;
}

.document {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pageInfo {
  margin-top: 10px;
  text-align: center;
  font-weight: 500;
}

.container {
  background-color: var(--bs-secondary);
  padding: 0.5rem;
}

/* Mode plein écran */
.container:fullscreen {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.container:fullscreen .scrollContainer {
  max-height: calc(100vh - 60px);
  flex: 1;
}

.container:fullscreen .header {
  background-color: var(--bs-primary);
  color: white;
  padding: 10px 20px;
}

.container:fullscreen .pageInfo {
  color: white;
}

/* Styles pour l'impression - spécialisés uniquement quand le PDF est affiché */
@media print {
  /* Configuration de la page pour l'impression de PDF */
  @page {
    margin: 0;
    size: auto;
  }

  /* Retirer toutes les marges de la page uniquement si un PDF est présent */
  body:has(.container) {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Cacher tout le contenu de la page sauf le PDF */
  body:has(.container) * {
    visibility: hidden;
  }

  /* Cacher le header avec les boutons lors de l'impression */
  .header {
    display: none !important;
  }

  /* Cacher la barre latérale des miniatures lors de l'impression */
  .thumbnailsSidebar {
    display: none !important;
  }

  /* Cacher le scrollContainer et afficher directement le document */
  .scrollContainer {
    max-height: none !important;
    overflow: visible !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Positionner le container pour l'impression */
  .container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background: none;
    padding: 0;
    margin: 0;
  }

  /* Afficher uniquement le conteneur du PDF et son contenu */
  body:has(.container) .container,
  body:has(.container) .container * {
    visibility: visible;
  }

  /* Retirer les marges entre les pages */
  .page {
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
  }

  .page canvas {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Centrer le document */
  .document {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }
}
